import React, { useEffect, useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import './payments.css'
import { Col, Row } from 'react-bootstrap'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import { PAYMENTS_MENUS } from '../Layout/menu-names'
import { getAccountListSelector, getMenuListSelector } from '../../store/selectors/app.selector'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
// import PaymentsService from '../../services/payments.service'
// import Data from "custom/assets/payments/Data.svg"
// import CashIn from "custom/assets/payments/Cash_In.svg"
// import CashOut from "custom/assets/payments/Cash_Out.svg"
// import TopUp from "custom/assets/payments/Top_Up.svg"

// const ICONS ={
//   DATA: Data,
//   CASHIN: CashIn,
//   CASHOUT: CashOut,
//   TOPUP: TopUp
// }

export default function Payments() {
  const history = useHistory()
  const accounts = useSelector(getAccountListSelector) || []
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['PAYMENTS'] || {}

  // const [billerList, setBillerList] = useState([])

  useEffect(() => {
    // getBillProducts()
  }, [])

  

  return (
    <LayoutWithAccountCard breadCumKey='PAYMENTS'>
      <Row>
        {Object.keys(menuConfig).length > 0 &&
          PAYMENTS_MENUS.map((option, index) => (
            <>
              {menuConfig[option.key] && (
                <Col
                  xs={'auto'}
                  sm={'auto'}
                  md={'auto'}
                  key={index}
                  className='account-menu-card'
                  onClick={() => (accounts.length > 0 ? history.push(option?.link) : '')}>
                  <img width={52} height={40} src={option?.icon} />
                  <h2>{t(option?.title)}</h2>
                  <span>{t(option.desc)}</span>
                </Col>
              )}
            </>
          ))}

        {/* {billerList.map((option, index) => (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() =>
              accounts.length > 0
                ? history.push({
                    pathname: '/payments/servicesView',
                    state: { categoryDetails: option },
                  })
                : ''
            }>
            <img width={52} height={40} src={option?.icon} />
            <h3>{t(option?.description)}</h3>
            <span>{t(option.title)}</span>
          </Col>
        ))} */}
      </Row>
    </LayoutWithAccountCard>
  )
}
